import $ from 'jquery';
import { frame, unframe } from './drawing';

const $window = $(window);
const properties = {};

function updateDimensions() {
    properties.width = $window.width();
    properties.height = $window.height();
}

function updateScroll() {
    properties.scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
    properties.scrollLeft = document.documentElement.scrollLeft || document.body.scrollLeft;
    properties.scrollWidth = document.documentElement.scrollWidth || document.body.scrollWidth;
    properties.scrollHeight = document.documentElement.scrollHeight || document.body.scrollHeight;
}

updateDimensions();
updateScroll();

$window.on('load resize', () => { updateDimensions(); updateScroll(); });
$window.on('scroll', () => { updateScroll(); });

/**
 * Returns all the above properties of the window object.
 *
 * @returns Object
 */
export function getProperties() {
    return Object.assign({}, properties);
}

/**
 * Returns the width of the window in pixels.
 *
 * @returns Number
 */
export function getWidth() {
    return properties.width;
}

/**
 * Returns the height of the window in pixels.
 *
 * @returns Number
 */
export function getHeight() {
    return properties.height;
}

/**
 * Returns the top scroll value of the window in pixels.
 *
 * @returns Number
 */
export function getScrollTop() {
    return properties.scrollTop;
}

/**
 * Returns the left scroll value of the window in pixels.
 *
 * @returns Number
 */
export function getScrollLeft() {
    return properties.scrollLeft;
}

/**
 * Returns the scrollable width of the window in pixels.
 *
 * @returns Number
 */
export function getScrollWidth() {
    return properties.scrollWidth;
}

/**
 * Returns the scrollable height of the window in pixels.
 *
 * @returns Number
 */
export function getScrollHeight() {
    return properties.scrollHeight;
}

/**
 * Binds a callback to resize events in a performant way.
 * Returns a function that, when called, unbinds the events.
 *
 * @param callback
 * @returns {Function}
 */
export function onResize(callback) {
	let currentFrame;
	function debounce(e) {
		unframe(currentFrame);
		currentFrame = frame(() => callback(e));
	}

	$window.on('load resize', debounce);

	callback();

	return () => $window.off('load resize', debounce);
}

/**
 * Binds a callback to scrolling events in a performant way.
 * Returns a function that, when called, unbinds the events.
 *
 * @param callback
 * @returns {Function}
 */
export function onScroll(callback) {
    let currentFrame;
    function debounce(e) {
        unframe(currentFrame);
        currentFrame = frame(() => callback(e));
    }

    $window.on('load resize scroll', debounce);

    callback();

    return () => $window.off('load resize scroll', debounce);
}



// WEBPACK FOOTER //
// ./source/scripts/utils/window.js